import { DEMO_USER_IDS } from "src/mockData/demoContractData"
import type { Deal } from "@/types/deal.types"

export const INITIAL_DEALS: Deal[] = [
  {
    id: "deal-1",
    name: "Sony Music Partnership",
    type: "Record Label",
    dealType: "music",
    stage: "in_progress",
    value: 250000,
    date: "Dec 1, 2024",
    progress: 65,
    documentsCount: 8,
    collaborators: [DEMO_USER_IDS.ADAM_SILVER, DEMO_USER_IDS.ROGER_GOODELL],
    lastActivity: "2 hours ago",
    dueDate: "Jan 15, 2025",
    description: "Exclusive distribution and marketing partnership",
  },
  {
    id: "deal-2",
    name: "Netflix Sync License",
    type: "Sync License",
    dealType: "music",
    stage: "lead",
    value: 45000,
    date: "Nov 28, 2024",
    progress: 40,
    documentsCount: 3,
    collaborators: [DEMO_USER_IDS.ADAM_SILVER],
    lastActivity: "1 day ago",
    dueDate: "Dec 30, 2024",
    description: "Music placement for documentary series",
  },
  {
    id: "deal-3",
    name: "Series A Investment",
    type: "Venture Capital",
    dealType: "vc",
    stage: "lead",
    value: 2000000,
    date: "Nov 15, 2024",
    progress: 15,
    documentsCount: 2,
    collaborators: [],
    lastActivity: "3 days ago",
    dueDate: "Feb 1, 2025",
    description: "Early stage investment round for tech startup",
  },
  {
    id: "deal-4",
    name: "Spotify Playlist Placement",
    type: "Distribution",
    dealType: "music",
    stage: "complete",
    value: 12000,
    date: "Nov 10, 2024",
    progress: 100,
    documentsCount: 4,
    collaborators: [DEMO_USER_IDS.ROGER_GOODELL],
    lastActivity: "1 week ago",
    dueDate: null,
    description: "Featured playlist placement agreement",
  },
  {
    id: "deal-5",
    name: "Nike Brand Ambassador",
    type: "Endorsement",
    dealType: "partnership",
    stage: "in_progress",
    value: 500000,
    date: "Nov 5, 2024",
    progress: 80,
    documentsCount: 12,
    collaborators: [DEMO_USER_IDS.ADAM_SILVER, DEMO_USER_IDS.ROGER_GOODELL],
    lastActivity: "5 hours ago",
    dueDate: "Dec 20, 2024",
    description: "Multi-year brand partnership and social campaign",
  },
  {
    id: "deal-6",
    name: "Seed Round - Fintech",
    type: "Venture Capital",
    dealType: "vc",
    stage: "signing",
    value: 750000,
    date: "Oct 28, 2024",
    progress: 25,
    documentsCount: 1,
    collaborators: [],
    lastActivity: "2 weeks ago",
    dueDate: "Mar 1, 2025",
    description: "Seed investment in payment processing startup",
  },
  {
    id: "deal-7",
    name: "Feature Collaboration - Drake",
    type: "Collaboration",
    dealType: "music",
    stage: "in_progress",
    value: 150000,
    date: "Oct 20, 2024",
    progress: 55,
    documentsCount: 5,
    collaborators: [DEMO_USER_IDS.ADAM_SILVER],
    lastActivity: "4 days ago",
    dueDate: "Jan 10, 2025",
    description: "Guest feature split and production agreement",
  },
  {
    id: "deal-8",
    name: "Co-Marketing Agreement",
    type: "Partnership",
    dealType: "partnership",
    stage: "delivery",
    value: 35000,
    date: "Oct 15, 2024",
    progress: 100,
    documentsCount: 6,
    collaborators: [DEMO_USER_IDS.ROGER_GOODELL],
    lastActivity: "3 weeks ago",
    dueDate: null,
    description: "Joint marketing campaign with lifestyle brand",
  },
  {
    id: "deal-9",
    name: "Publishing Admin Agreement",
    type: "Publishing",
    dealType: "music",
    stage: "lead",
    value: 75000,
    date: "Oct 12, 2024",
    progress: 20,
    documentsCount: 3,
    collaborators: [DEMO_USER_IDS.ADAM_SILVER],
    lastActivity: "5 days ago",
    dueDate: "Jan 20, 2025",
    description: "Global publishing administration deal",
  },
  {
    id: "deal-10",
    name: "Angel Investment - AI Startup",
    type: "Venture Capital",
    dealType: "vc",
    stage: "in_progress",
    value: 100000,
    date: "Oct 8, 2024",
    progress: 60,
    documentsCount: 4,
    collaborators: [],
    lastActivity: "1 day ago",
    dueDate: "Dec 31, 2024",
    description: "Angel round for AI/ML company",
  },
]
